const displayLayout = {
    namespaced: true,
    state: {
        layoutList: [],
        layoutParameterList: []
    },
    mutations: {
        updateLayoutList(state, newList) {
            state.layoutList = newList;
        },
        updateLayoutParameterList(state, newList) {
            state.layoutParameterList = newList;
        }
    },
    actions: {
        getLayoutList(context) {
            this._vm.$traveller_http.get('/traveller/restui/displaylayout/getlayouts')
            .then(function(response) {
                context.commit('updateLayoutList', response.data);
            })
        },
        saveLayout(context, formLayout) {
            var newLayout = { ...formLayout };
            var configuration = [];
            for (const conf in newLayout.layoutConfiguration) {
                var confParam = {};
                confParam.id = conf;
                confParam.value = newLayout.layoutConfiguration[conf];
                configuration.push(confParam);
            }
            newLayout.layoutConfiguration = configuration;
            delete newLayout.usage;
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/displaylayout/savelayout', newLayout)
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getLayoutList');
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        deleteLayout(context, id) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/displaylayout/deletelayout', { params: { "id": id } })
                    .then(response => {
                        if (response.status == 200) {
                            context.dispatch('getLayoutList');
                        }
                        resolve(response);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        getLayoutParameterList(context) {
            this._vm.$traveller_http.get('/traveller/restui/displaylayout/getvalidparameters')
            .then( response => {
                context.commit('updateLayoutParameterList', response.data)
            })
        }
    }
}
export default displayLayout;